import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

import { ghinLogin, clearToken } from '../usga/apis/auth';
import { GHIN_STAGING_URL } from '../usga/apis/config';

interface USGAContextModel {
  usgaUrl: string;
  isUSGALoggedIn: boolean;
  usgaLogin: (email: string, password: string) => Promise<{ success: boolean; error?: string }>;
  usgaLogout: () => void;
}

const USGAContext = createContext<USGAContextModel | undefined>(undefined);

export function USGAProvider({ children }: { children: ReactNode }) {
  const [isUSGALoggedIn, setIsUSGALoggedIn] = useState(false);

  const usgaLoginFn = useCallback(async (email: string, password: string) => {
    const result = await ghinLogin({ email, password });
    if (result.success) {
      setIsUSGALoggedIn(true);
      return { success: true };
    }
    return { success: false, error: result.error };
  }, []);

  const usgaLogout = useCallback(() => {
    clearToken();
    setIsUSGALoggedIn(false);
  }, []);

  return (
    <USGAContext.Provider value={{
      usgaUrl: GHIN_STAGING_URL,
      isUSGALoggedIn,
      usgaLogin: usgaLoginFn,
      usgaLogout,
    }}>
      {children}
    </USGAContext.Provider>
  );
}

export function useUSGA(): USGAContextModel {
  const ctx = useContext(USGAContext);
  if (!ctx) throw new Error('useUSGA must be used within USGAProvider');
  return ctx;
}
